import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, KeepAlive as _KeepAlive, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-180d87a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header"
}

import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import { Subscription } from "@/models/Subscription";

export default /*#__PURE__*/_defineComponent({
  props: {
  subscriptionID: { type: String, required: false },
  typeName: { type: String, required: false, default: "new" },
},
  setup(__props) {

const props = __props

const route = useRoute();

// eslint-disable-next-line no-undef

const selectedSubscription = ref<Subscription | undefined>(undefined);

watch(
  () => route.params.subscriptionID,
  async (sId) => {
    if (route.params.subscriptionID) {
      selectedSubscription.value = await Subscription.fetch(
        route.params.subscriptionID as string
      );
    } else {
      selectedSubscription.value = undefined;
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (selectedSubscription.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Update Subscription"))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        Component
          ? (_openBlock(), _createBlock(_KeepAlive, { key: 0 }, [
              (_openBlock(), _createBlock(_Suspense, {
                key: _ctx.$route.fullPath
              }, {
                fallback: _withCtx(() => [
                  _createVNode(_component_va_inner_loading, { loading: true })
                ]),
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                    key: _ctx.$route.fullPath
                  }))
                ]),
                _: 2
              }, 1024))
            ], 1024))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})